import { render, staticRenderFns } from "./MenuMgtView.vue?vue&type=template&id=310b83b2&scoped=true"
import script from "./MenuMgtView.vue?vue&type=script&lang=js"
export * from "./MenuMgtView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310b83b2",
  null
  
)

export default component.exports